import { ButtonSizeSM, ButtonSkinAbsoluteWhite } from '@picsart/button';
import Button from '@picsart/button/Button';
import { FontWeights, Texts, Typography } from '@picsart/cascade';
import { Text } from '@picsart/text';
import { useTranslation } from 'react-i18next';
import IconArrowRightLarge from '@picsart/icons/IconArrowRightLarge';

import analytics from '../../../services/analytics';
import { getCategoryName } from '../../../utils/common/category';
import { AD_WRITER_CATEGORY } from '../../../constants';

import useStyles from './styles';

const AD_MAKER_URL = 'https://onlineadmaker.com';

function AdMakerBanner() {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleGoToLink = () => {
    analytics.pageClick({
      page_path: window.location.pathname,
      action_type: 'try_for_free',
      category_name: getCategoryName(AD_WRITER_CATEGORY),
    });
    window.open(AD_MAKER_URL, '_blank');
  };
  return (
    <div className={classes.banner}>
      <img
        className={classes.image}
        src="https://pastatic.picsart.com/cms-pastatic/c9b1cfa0-2330-4ccb-8794-912c74913eb6.png"
        alt="Admaker"
      />
      <div className={classes.textContainerWeb}>
        <Text size={Typography.t5} weight={FontWeights.SemiBold} color={Texts.negative}>
          {t('editor.admakerBanner.title')}
        </Text>
        <Text size={Typography.t4} weight={FontWeights.Medium} color={Texts.negative}>
          {t('editor.admakerBanner.description')}
        </Text>
      </div>
      <div className={classes.textContainerMobile}>
        <Text size={Typography.t4} weight={FontWeights.SemiBold} color={Texts.negative}>
          {t('editor.admakerBanner.mobileText')}
        </Text>
        <Text
          onClick={handleGoToLink}
          className={classes.mobileText}
          size={Typography.t4}
          weight={FontWeights.SemiBold}
          color={Texts.positive}
        >
          {t('editor.admakerBanner.buttonText')}
        </Text>
      </div>
      <Button
        onClick={handleGoToLink}
        className={classes.button}
        size={ButtonSizeSM}
        endIcon={IconArrowRightLarge}
        skin={ButtonSkinAbsoluteWhite}
      >
        {t('editor.admakerBanner.buttonText')}
      </Button>
    </div>
  );
}
export default AdMakerBanner;
